import { render, staticRenderFns } from "./vant-newselect.vue?vue&type=template&id=a423388a&scoped=true&"
import script from "./vant-newselect.vue?vue&type=script&lang=ts&"
export * from "./vant-newselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a423388a",
  null
  
)

export default component.exports